import { Component, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren, ViewContainerRef } from '@angular/core';
import { DynamicComponent, HisNotificationService, HisUiService, HisGenericValueService,
    HisBaseGlobalsService, HisNavigationService } from 'hisng';

import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';
import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { SEARCH_CONFIG_INFRASTRUCTURE } from 'app/fs/res/common/model/searchConstants';

import { ResearchInfrastructure, SimpleResearchInfrastructure } from 'app/fs/res/research-infrastructure/model/research-infrastructure';
import { ResearchInfrastructureService } from 'app/fs/res/research-infrastructure/service/research-infrastructure.service';

@Component({
    selector: 'res-infrastructure-panel',
    templateUrl: './research-infrastructure-panel.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructurePanelComponent)],
})
export class ResearchInfrastructurePanelComponent implements OnInit {
    @Input() selectedInfrastructures: ResearchInfrastructure[];
    @Input() selectedInfrastructure: SimpleResearchInfrastructure;
    @Input() dDKey = 'fs.res.common.researchInfrastructures';
    @Input() editMode = true;
    @Input() dynamicComponent: DynamicComponent;
    @Input() infoMessage: string;
    @Output() selectedInfrastructuresChange = new EventEmitter<ResearchInfrastructure[]>();
    @Output() routerContextChange = new EventEmitter();
    @Output() tabIndexChanged = new EventEmitter();
    @Output() onBeforeNavigate = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    showInfrastructureViewBtn =false;

    readonly SEARCH_CONFIG_INFRASTRUCTURE= SEARCH_CONFIG_INFRASTRUCTURE;

    //showPubViewBtn = false;

    constructor( private hisUiService: HisUiService,
        private notificationService: HisNotificationService,
        private genericValueService: HisGenericValueService,
        private hisBaseGlobalsService: HisBaseGlobalsService,
        private navigationService: HisNavigationService,
        private infrastructureService: ResearchInfrastructureService ) {
    }
    ngOnInit(): void {
        this.showInfrastructureViewBtn = this.hisBaseGlobalsService.isAnyModuleActive('HISINONERES');
    }

    public getOperatorsAsString(event: ResearchInfrastructure): string {
        /* get all containing Operators */
        let operatorsStr = '';
        if (event.researchInfrastructureOrganisations) {
            for (let op of event.researchInfrastructureOrganisations.filter(org => !org.isCoordinator)){
                if(op.researchPartner){
                    operatorsStr +=  op.researchPartner.defaulttext + ',';
                }
                else if (op.orgunit) {
                    operatorsStr +=  op.orgunit.text + ',';
                }
            }
            operatorsStr = operatorsStr.substring(0,operatorsStr.length-1);
        }
        return operatorsStr;
    }

    /**
     * get infrastructures involved with
     */
    getSelectedInfrastructures(): ResearchInfrastructure[] {
        return this.selectedInfrastructures;
    }

    onSelectBySearchPopup(event: any[]) {
        if (!event || event.length === 0) {
            // the selected list has been emptied
            this.selectedInfrastructures = [];
            this.selectedInfrastructuresChange.emit(this.selectedInfrastructures);
        } else {
            // convert search result into ResearchInfrastructure[]
            let infrastructureIds: number[] = event.map(searchResultRow => parseInt(searchResultRow.id, 10));
            this.infrastructureService.getResearchInfrastructuresByIds(infrastructureIds).subscribe(
                (infrastructures: ResearchInfrastructure[]) => {
                    this.selectedInfrastructures = infrastructures;
                    this.selectedInfrastructuresChange.emit(this.selectedInfrastructures);
                });
        }
    }

    onSelectByAutocomplete() {
        if (!this.selectedInfrastructure) {
            this.notificationService.errorI18nRes('fs.res.common.error.researchInfrastructure');
        } else {
            let containedInfra =
                this.genericValueService.findRowByValue(this.selectedInfrastructures, this.selectedInfrastructure.id);
            if (!containedInfra) {
                this.infrastructureService.getResearchInfrastructureById(this.selectedInfrastructure.id).subscribe(
                    (p: ResearchInfrastructure) => {
                        this.selectedInfrastructures = [...this.selectedInfrastructures, p];
                        this.selectedInfrastructuresChange.emit(this.selectedInfrastructures);
                        this.selectedInfrastructure = undefined;
                    });
            } else {
                this.notificationService.warn(
                    this.hisUiService.translate(
                        'fs.res.common.warning.infrastructureAlreadyAssigned', '"' + containedInfra.title + '"'),
                    this.hisUiService.translate('fs.res.common.service.warn')
                );
            }
        }
    }

    /**
     * remove ResearchInfrastructure with given index
     *
     * @param infrastructure infrastructure to remove.
     */
    removeInfrastructure(infrastructure: ResearchInfrastructure) {
        const index = this.selectedInfrastructures.indexOf(infrastructure);
        this.selectedInfrastructures = this.genericValueService.deleteRow(this.selectedInfrastructures, index);
        this.selectedInfrastructuresChange.emit(this.selectedInfrastructures);
    }

    /* navigation to ResearchInfrastructur detail-view */
    onNavigate() {
        this.onBeforeNavigate.emit();
        this.navigationService.setLastBackUrl(window.location.href);
        this.routerContextChange.emit();
    }

}
